import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-column justify-content-around min-h-full fadeinright"
}
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "px-2 font-semibold"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "font-light text-xs" }
const _hoisted_9 = { class: "flex align-items-center justify-content-center pl-4" }
const _hoisted_10 = { class: "px-2" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "font-light text-xs"
}
const _hoisted_13 = {
  key: 1,
  class: "info-icon-container"
}
const _hoisted_14 = { class: "bg-my-gray border-round-md p-1 flex-column-reverse flex-grow-1 flex" }

import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useMessageCenterStore } from '@/store';
import AutoComplete from 'primevue/autocomplete';
import Initials from '@/components/Initials';
import InputMessage from '../Chat/components/InputMessage.vue';
import { NewChatSelectedPeople, RecipientData } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'NewChat',
  setup(__props) {

const messageCenter = useMessageCenterStore();
const { recipients, error } = storeToRefs(messageCenter);

const hasError = computed(() => !!error.value);

const selectedPeople = ref([]);
const sendingMessage = ref(false);
const autocomplete = ref();

const selectedPeopleIds = computed(() => {
  const data: NewChatSelectedPeople = {
    singlePeopleIds: [],
    teamsNames: [],
    teamsParticipants: [],
    teams: [],
  };

  selectedPeople.value.map((recipient: RecipientData) => {
    if (recipient.ids) {
      data.teamsParticipants.push(...recipient.ids);
      data.teamsNames.push(recipient.name);
      const team = {
        person_id: recipient.person_id,
        participants: recipient.ids,
      };
      data.teams.push(team);
    } else {
      data.singlePeopleIds.push(recipient.id);
    }
  });

  return data;
});

const filteredPeople = ref();

const removeError = () => {
  messageCenter.error = undefined;
};

const startNewChat = async (messageData: FormData) => {
  let memberIds = selectedPeopleIds.value.singlePeopleIds;
  let teamNames = selectedPeopleIds.value.teamsNames.join(', ');
  memberIds = memberIds.concat(selectedPeopleIds.value.teamsParticipants);

  if (memberIds.length === 0) {
    messageCenter.doToast('Please select at least one person or team to start a chat.', 'Error', true);
    return;
  }

  sendingMessage.value = true;

  const newChat = new FormData();
  newChat.append('name', teamNames);
  memberIds.forEach((id) => newChat.append('members[]', id.toString()));
  newChat.append('content', messageData.get('content') || '');
  newChat.append('type', messageData.get('type') || 'text');
  if (messageData.get('attachment[]')) {
    for (let i = 0; i < messageData.getAll('attachment[]').length; i++) {
      newChat.append('attachment[]', messageData.getAll('attachment[]')[i] as Blob);
    }
  }

  messageCenter.messageText = '';

  messageCenter.createNewChat(newChat);

  if (hasError.value) {
    const message = error.value.data.errors
      ? Object.values(error.value.data.errors).flat().join(', ')
      : error.value.data.message;

    messageCenter.doToast(message, 'Error', true, 5000);
    removeError();
  }

  selectedPeople.value = [];
  messageCenter.screen = 'list-chats';
  sendingMessage.value = false;
};

const mountRecipientsTeams = (recipients: RecipientData[]) => {
  const recipientsClone = [...recipients];

  for (const recipient of recipientsClone) {
    if (recipient.associated.length > 0) {
      recipient.associated.unshift(recipient.team);
    }
  }
  return recipientsClone;
};

const filterPeople = async (event) => {
  await messageCenter.getAvailableMembers(event.query);
  filteredPeople.value = mountRecipientsTeams(recipients.value);
};

const selectPerson = (event, item) => {
  if (checkSelected(item)) return;
  autocomplete.value.onOptionSelect(event, item);
};

const checkSelected = (data) => {
  return (
    selectedPeopleIds.value.singlePeopleIds.includes(data.id) ||
    (data.ids && selectedPeopleIds.value.teamsNames.includes(data.name))
  );
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Loader = _resolveComponent("Loader")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(can)([_unref(PERMISSIONS).CHAT_AVAILABLE_MEMBERS, _unref(PERMISSIONS).CHAT_ADD_MEMBER]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(AutoComplete), {
            ref_key: "autocomplete",
            ref: autocomplete,
            modelValue: selectedPeople.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPeople).value = $event)),
            suggestions: filteredPeople.value,
            multiple: true,
            "min-length": 3,
            field: "name",
            delay: 500,
            "scroll-height": '600px',
            "option-group-label": "name",
            "option-group-children": "associated",
            "input-class": "h-full",
            "panel-class": "new-message-autocomplete new-chat",
            class: "pb-3 mt-1 new-message-recipients",
            onComplete: _cache[1] || (_cache[1] = ($event: any) => (filterPeople($event)))
          }, {
            chip: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_2, [
                (slotProps.value.ids)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      name: "group",
                      class: "icon-group"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_3, _toDisplayString(slotProps.value.name), 1)
              ])
            ]),
            optiongroup: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-content-between align-items-center cursor-pointer text-sm p-3 row-select", { selected: checkSelected(slotProps.option) }])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(Initials), {
                    initials: slotProps.option.initials,
                    size: 18
                  }, null, 8, ["initials"]),
                  (slotProps.option.user)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "px-2 font-semibold",
                        onClick: ($event: any) => (selectPerson($event, slotProps.option))
                      }, _toDisplayString(slotProps.option.name), 9, _hoisted_5))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(slotProps.option.name), 1)),
                  (slotProps.option.selected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Selected"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(slotProps.option.type), 1)
              ], 2)
            ]),
            option: _withCtx((slotProps) => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-content-between align-items-center cursor-pointer text-sm p-3 row-select", { selected: checkSelected(slotProps.option) }])
              }, [
                _createElementVNode("div", _hoisted_9, [
                  (slotProps.option.initials)
                    ? (_openBlock(), _createBlock(_unref(Initials), {
                        key: 0,
                        initials: slotProps.option.initials,
                        size: 18
                      }, null, 8, ["initials"]))
                    : (_openBlock(), _createBlock(_component_Icon, {
                        key: 1,
                        name: "group",
                        class: "text-medium"
                      })),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(slotProps.option.name), 1),
                  (slotProps.option.selected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Selected"))
                    : _createCommentVNode("", true)
                ]),
                (slotProps.option.initials)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(slotProps.option.type), 1))
                  : _createCommentVNode("", true),
                (!slotProps.option.initials)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _withDirectives(_createVNode(_component_Icon, {
                        name: "info",
                        class: "text-gray-500 text-s"
                      }, null, 512), [
                        [
                          _directive_tooltip,
                          {
                value: 'A student\'s care team includes all service providers and guardians connected to the student',
                pt: {
                  text: {
                    class: 'custom-tooltip-text',
                  },
                  arrow: {
                    class: 'custom-tooltip-arrow',
                  },
                },
              },
                          void 0,
                          { left: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 1
          }, 8, ["modelValue", "suggestions"]),
          _createElementVNode("div", _hoisted_14, [
            (_unref(can)([_unref(PERMISSIONS).MESSAGE_STORE]))
              ? (_openBlock(), _createBlock(InputMessage, {
                  key: 0,
                  class: "w-full",
                  onMessageSent: startNewChat
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (sendingMessage.value)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          class: "absolute left-0 top-0 flex justify-content-center align-items-center w-full h-full loader"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})